module.exports = __webpack_public_path__ + "static/img/enterprise-big-3.0d45115b.png";